import {
  subscriptionStatusLabel,
  subscriptionStatusClass,
} from '../../lib/billing-format.js';

/**
 * Pill showing the tenant's subscription status.
 *
 * States match Stripe's canonical subscription statuses + our own
 * "founder" and "suspended" extensions:
 *   trialing / active / past_due / suspended / cancelled / founder /
 *   incomplete / unpaid
 */
export function SubscriptionStatusPill({ status }) {
  return (
    <span className={`sub-status ${subscriptionStatusClass(status)}`}>
      {subscriptionStatusLabel(status)}
    </span>
  );
}
